module.exports = __webpack_public_path__ + "img/table-sort-desc-light.f1d990ad.svg";